import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { AdminLayoutComponent } from './core/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './core/layouts/auth-layout/auth-layout.component';
import { PublicLayoutComponent } from './core/layouts/public-layout/public-layout.component';
import { permisosMenuUser } from './pages/auth/constants/menuUsers.constant';
import { MicrosoftLoginGuard } from './pages/auth/guards/microsoft-login.guard';
import { MicrosoftRolesGuard } from './pages/auth/guards/microsoft-roles.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    data: {
      breadcrumb: { skip: true },
    },
    children: [
      {
        path: 'login',
        component: AuthLayoutComponent,
        loadChildren: () =>
          import('./pages/auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: 'registros',
        children: [
          {
            path: '',
            canActivate: [MicrosoftLoginGuard, MicrosoftRolesGuard],
            component: AdminLayoutComponent,
            data: {
              rolUsuario: permisosMenuUser.REGISTROS,
              breadcrumb: {
                label: 'Registros de Aspirantes',
                alias: 'RegistrosCrumb',
                info: 'fa-solid fa-table-list', //Solo poner el icono en la ruta de mayor gerarquia
              },
            },
            loadChildren: () =>
              import('./pages/admin/registros/registros.module').then(
                (m) => m.RegistrosModule
              ),
          },
          {
            path: '**',
            redirectTo: '',
          },
        ],
      },
      {
        path: 'movimientos',
        component: AdminLayoutComponent,
        data: {
          rolUsuario: permisosMenuUser.MOVIMIENTOS,
          breadcrumb: {
            label: 'Movimientos',
            alias: 'MovimientosCrumb',
            info: 'far fa-id-badge', //Solo poner el icono en la ruta de mayor gerarquia
          },
        },
        canActivate: [MicrosoftLoginGuard, MicrosoftRolesGuard],
        loadChildren: () =>
          import('./pages/movimientos/movimientos.module').then(
            (m) => m.MovimientosModule
          ),
      },
      {
        path: 'reportes',
        canActivate: [MicrosoftLoginGuard, MicrosoftRolesGuard],
        component: AdminLayoutComponent,
        data: {
          rolUsuario: permisosMenuUser.REPORTES,
          breadcrumb: {
            label: 'Reportes',
            alias: 'ReportessCrumb',
            info: 'fa-solid fa-calendar-days', //Solo poner el icono en la ruta de mayor gerarquia
          },
        },
        loadChildren: () =>
          import('./pages/admin/reportes/reportes.module').then(
            (m) => m.ReportesModule
          ),
      },
      {
        path: 'importador',
        children: [
          {
            path: '',
            canActivate: [MicrosoftLoginGuard, MicrosoftRolesGuard],
            component: AdminLayoutComponent,
            data: {
              rolUsuario: permisosMenuUser.IMPORTADOR,
              breadcrumb: {
                label: 'Importador de calificaciones',
                alias: 'ImportadorCrumb',
                info: 'fas fa-file-import', //Solo poner el icono en la ruta de mayor gerarquia
              },
            },
            loadChildren: () =>
              import('./pages/admin/importador/importador.module').then(
                (m) => m.ImportadorModule
              ),
          },
          {
            path: '**',
            redirectTo: '',
          },
        ],
      },
      // {
      //   path: 'usuario',
      //   canActivate: [MicrosoftLoginGuard, MicrosoftRolesGuard],
      //   data: {
      //     rolUsuario: permisosMenuUser.REGISTROS,
      //   },
      //   loadChildren: () =>
      //     import('./pages/auth/components/perfil/usuario.module').then(
      //       (m) => m.UsuarioModule
      //     ),
      // },
      {
        path: '**',
        redirectTo: 'registros',
      },
    ],
  },
  // {
  //   path: 'aspirante',
  //   data: {
  //     breadcrumb: {
  //       skip: true,
  //     },
  //   },
  //   children: [
  //     {
  //       path: 'preregistro',
  //       component: AuthLayoutComponent,
  //       loadChildren: () =>
  //         import('./pages/aspirante/preregistro/preregistro.module').then(
  //           (m) => m.PreregistroModule
  //         ),
  //     },
  //     {
  //       path: 'registro',
  //       component: AdminLayoutComponent,
  //       canActivate: [AspiranteJWTrGuard],
  //       data: {
  //         breadcrumb: { skip: true },
  //       },
  //       loadChildren: () =>
  //         import('./pages/aspirante/registro/registro.module').then(
  //           (m) => m.RegistroModule
  //         ),
  //     },
  //     {
  //       path: '',
  //       component: AuthLayoutComponent,
  //       loadChildren: () =>
  //         import('./pages/aspirante/auth/aspirante-auth.module').then(
  //           (m) => m.AspiranteAuthModule
  //         ),
  //     },
  //     {
  //       path: '**',
  //       redirectTo: '',
  //     },
  //   ],
  // },
  {
    path: 'results',
    data: {
      breadcrumb: {
        skip: true,
      },
    },
    children: [
      {
        path: 'show',
        component: PublicLayoutComponent,
        loadChildren: () =>
          import('./pages/results/show-results/show-results.module').then(
            (m) => m.ShowResultsModule
          ),
      },
      {
        path: '**',
        redirectTo: 'show',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'admin',
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
